export const AccentHeading = ({ text = "", accent = "" }) => {
    const a = accent.trim();
    const idx = a ? text.toLowerCase().indexOf(a.toLowerCase()) : -1;
    if (idx === -1) return text;
    return (
        <>
            {text.slice(0, idx)}
            <span className="italic gold-text">{text.slice(idx, idx + a.length)}</span>
            {text.slice(idx + a.length)}
        </>
    );
};
